const imageSource = {
  filter: require("@app/assests/mock/filter.png"),
  logo: require("@app/assests/mock/admin-logo.png"),
  settings: require("@app/assests/mock/settings.png"),
  camera: require("@app/assests/mock/camera.png"),
  emailIcon: require("@app/assests/mock/email.png"),
  passwordIcon: require("@app/assests/mock/password.png"),
  userIcon: require("@app/assests/mock/user-icon.png"),

  // public assets
  kaizenMotor : "/assets/images/kaizen-motor.png",
  authSideBar : "/assets/images/auth-side-bar.png",

  // icon
  iconUser: "/assets/icons/navbar/ic_user.svg",
  iconModel: "/assets/icons/navbar/ic_model.svg",
  iconBrand: "/assets/icons/navbar/ic_brand.svg",
  iconCar: "/assets/icons/navbar/ic_car.svg",
  iconProducts: "/assets/icons/navbar/ic_products.svg",
  iconCustomers: "/assets/icons/navbar/ic_customers.svg",
  iconRequest: "/assets/icons/navbar/ic_request.svg",
  iconDashboard: "/assets/icons/navbar/ic_dashboard.svg",
};

export { imageSource };
